import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const Action = (props: GridCellProps) => {
  const { redirect, getUrl } = useRedirect();
  const {
    dataItem: { invoiceId, poId, invoiceNumber },
  } = props;
  const { value } = useGridCellDisplayValue(props);

  const handleClick = useCallback(() => {
    redirect(getUrl('invoiceDetails')(invoiceId, poId));
  }, [getUrl, invoiceId, poId, redirect]);

  return (
    <GridCellBase
      {...props}
      title={invoiceNumber ? `${value}(${invoiceNumber})` : value}
      className="!text-left"
    >
      {invoiceNumber ? (
        <p>
          {value} (
          <span className="text-link cursor-pointer underline" onClick={handleClick}>
            {invoiceNumber}
          </span>
          )
        </p>
      ) : (
        <span>{value}</span>
      )}
    </GridCellBase>
  );
};
export default Action;
